export const fmtAUD = (v) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(v || 0);

// v1.0.16 display rule: authoritative stored contract values remain GST Inclusive;
// user-facing display basis is Excl. GST (÷ 1.1, 2dp) everywhere except Project Register rows.
export const exGst = (v) => Math.round(((v || 0) / 1.1) * 100) / 100;
export const fmtAUDex = (v) => fmtAUD(exGst(v));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return (
    d.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" }) +
    " " +
    d.toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit" })
  );
};

export function projectLabel(p) {
  const a = p?.address || {};
  const rest = [a.suburb, a.state, a.postcode].filter(Boolean).join(" ");
  return [a.street, rest].filter(Boolean).join(", ") || "No address recorded";
}

// status tone: green | amber | red | blue(legacy neutral) | grey
export const TONE_CLASSES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  orange: "bg-orange-50 text-orange-700 border-orange-200",
  red: "bg-red-50 text-red-700 border-red-200",
  blue: "bg-gray-100 text-gray-700 border-gray-300",
  sky: "bg-sky-50 text-sky-700 border-sky-200",
  grey: "bg-gray-100 text-gray-600 border-gray-200",
};

export const TONE_STRIP = {
  green: "border-t-emerald-500",
  amber: "border-t-amber-500",
  orange: "border-t-orange-500",
  red: "border-t-red-500",
  blue: "border-t-gray-500",
  sky: "border-t-sky-500",
  grey: "border-t-gray-300",
};

export const TONE_DOT = {
  green: "bg-emerald-500",
  amber: "bg-amber-500",
  orange: "bg-orange-500",
  red: "bg-red-500",
  blue: "bg-gray-500",
  sky: "bg-sky-500",
  grey: "bg-gray-400",
};

export function statusTone(status) {
  const s = (status || "").toLowerCase();
  if (["connected", "completed", "complete", "payment confirmed", "approved", "yes", "confirmed", "submitted"].includes(s)) return "green";
  if (["overdue", "rejected", "no", "problem"].includes(s)) return "red";
  if (["pending", "awaiting", "awaiting retailer", "scheduled", "upcoming", "draft", "in progress", "current"].includes(s)) return "amber";
  if (s === "active") return "orange";
  return "grey";
}
